<template>
  <div class="row-card" :class="[ 'border-theme-' + theme ,{'multi-line-padding': multiLinePadding} ,{'multi-line-no-padding': multiLineNoPadding} ]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "RowCard",
  props: {
    theme: {
      default: ''
    },
    multiLine: {
      default: false
    },
    multiLinePadding: {
      default: false
    },
    multiLineNoPadding: {
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.row-card {
  background: #FFFFFF;
  border-radius: 20px;
  padding: 8px 33px 8px 16px;
  border-left: solid 20px #fff;
  min-height: 70px;
  width: 100%;
  display: flex;
  align-items:center ;
  justify-content: space-between;
  gap: 8px;
  font-family: var(--font-bold-type);
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1)
}
.multi-line{
  align-items:flex-start !important;
  padding: 20px 33px 20px 16px !important;
}
.border-theme-1 {
  border-color: var(--theme-color-one);
}
.border-theme-2 {
  border-color: var(--theme-color-two);
}
.border-theme-3 {
  border-color: var(--theme-color-three);
}
.border-theme-4 {
  border-color: var(--theme-color-four);
}
.border-theme-5 {
  border-color: var(--theme-color-five);
}
.border-theme-10 {
  border-color: var(--theme-color-ten);
}
.border-theme-none {
  border-left: solid 0px #fff !important;
}
.multi-line-padding{
  align-items:flex-start !important;
  padding: 24px !important;
  gap: 0 !important;
}
.multi-line-no-padding{
  align-items:flex-start !important;
  padding: 24px !important;
  gap: 0 !important;
}
</style>